var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { attrs: { id: _vm.id } },
    [
      _c("SectionTitle", [
        _vm._v(" " + _vm._s(_vm.$t(_vm.fieldConfig.label)) + " "),
      ]),
      _c("div", [
        _c(
          "div",
          { staticClass: "search-preference__alg-label" },
          [
            _c("label", { staticClass: "search-preferences--radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fieldValue,
                    expression: "fieldValue",
                  },
                ],
                attrs: { type: "radio" },
                domProps: {
                  value: _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.Blast,
                  checked: _vm._q(
                    _vm.fieldValue,
                    _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.Blast
                  ),
                },
                on: {
                  change: [
                    function ($event) {
                      _vm.fieldValue =
                        _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.Blast
                    },
                    _vm.syncChange,
                  ],
                },
              }),
              _c("span", { staticClass: "search-preferences--value" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("Search.labels.algorithmTypes.Blast")) +
                    " "
                ),
              ]),
            ]),
            _c("label", { staticClass: "search-preferences--radio" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fieldValue,
                    expression: "fieldValue",
                  },
                ],
                attrs: { type: "radio" },
                domProps: {
                  value: _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.NW,
                  checked: _vm._q(
                    _vm.fieldValue,
                    _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.NW
                  ),
                },
                on: {
                  change: [
                    function ($event) {
                      _vm.fieldValue =
                        _vm.MODIFICATION_SEARCH_ALGORITHM_TYPES.NW
                    },
                    _vm.syncChange,
                  ],
                },
              }),
              _c("span", { staticClass: "search-preferences--value" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("Search.labels.algorithmTypes.Nw")) + " "
                ),
              ]),
            ]),
            _c(
              "ElPopover",
              {
                attrs: {
                  "visible-arrow": false,
                  width: 458,
                  placement: "right",
                  trigger: "hover",
                  "popper-class": "bio-search-setting__popover",
                },
              },
              [
                _c("div", { staticClass: "preferences-propver__content" }, [
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "Search.propver.Preferences.algorithmDescription.1"
                        )
                      ),
                    },
                  }),
                  _c("img", {
                    attrs: {
                      src: _vm.store.safeImagesUrl(
                        "globalAlignmentExplanation.1"
                      ),
                    },
                  }),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "Search.propver.Preferences.algorithmDescription.2"
                        )
                      ),
                    },
                  }),
                  _c("img", {
                    attrs: {
                      src: _vm.store.safeImagesUrl(
                        "globalAlignmentExplanation.2"
                      ),
                    },
                  }),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "Search.propver.Preferences.algorithmDescription.3"
                        )
                      ),
                    },
                  }),
                ]),
                _c("PtIcon", {
                  staticStyle: { "margin-left": "12px" },
                  attrs: { slot: "reference", icon: "SolidInfo" },
                  slot: "reference",
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }